// detail
import styled from "styled-components"
// import buttonShare from '@/img/value-investment/share.png'
export const DetailToApp = styled.div`
    position: fixed;
    left: 50%;
    bottom: ${props=> props.bottom? '66px': '36px'};
    background-color: #ffc800;
    color: #fff;
    margin-left: -60px;
    border-radius: 18px;
    border: none;
    font-size: 17px;
    line-height: 20px;
    padding: 8px 20px;
    z-index: 100;
    text-align: center;
    font-weight: 400;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-self: center;   
    box-shadow: 0 2px 16px 0 rgb(0 0 0 / 20%);
    img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
      border-radius: 4px;
    }
    span{

    }
  .open-app {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;
  }
  .open-app img {
      width: 100%;
  }
`

export const DetailToBrowser = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  z-index: 9999;
  display:none;
  &.show{
    display:block;
  }
  img {
    width: 100%;
  }
`

export const WeichatBox = styled.div`
  position: fixed;
  left: 50%;
  bottom: ${props=> props.bottom? '66px': '36px'};
  margin-left: -60px;
  background-color: rgba(0, 0, 0, .5);
  width: 120px;
  height: 60px;
 
`


// WEBPACK FOOTER //
// ./src/components/OpenApp/style.js